module.exports = __webpack_public_path__ + "media/country_flags/vu-007cb386.png";